import { render, staticRenderFns } from "./CreatorDashboardMobile.vue?vue&type=template&id=9c810970&scoped=true"
import script from "./CreatorDashboardMobile.vue?vue&type=script&lang=js"
export * from "./CreatorDashboardMobile.vue?vue&type=script&lang=js"
import style0 from "./CreatorDashboardMobile.vue?vue&type=style&index=0&id=9c810970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c810970",
  null
  
)

export default component.exports